<style land="scss">
</style>

<template>
    <base-collapse :visible="visible" :accordion="accordion" :style-classes="styleClasses">
        <template #trigger>
            <div class="number"><slot name="number"></slot></div>
            <slot name="title"></slot>
        </template>
        <template #collapsed-content>
            <div class="collapsed-content">
                <slot name="collapsed-content"></slot>
            </div>
        </template>
    </base-collapse>
</template>

<script>
    import BaseCollapse from '../BaseCollapse.vue'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }            
        },
        components: {
            BaseCollapse
        },
        data() {
            return {
                styleClasses: {
                    "activity-collapse":  true,
                }
            }
        },
        methods: {}
    
}
</script>